import script from "./CustomerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerComp.vue?vue&type=script&setup=true&lang=js"

import "./CustomerComp.vue?vue&type=style&index=0&id=b89c8630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b89c8630"]])

export default __exports__